module.exports = __webpack_public_path__ + "images/anwb32957d8deb0cfa4905c12d0582eac963.png";